import React from 'react';
import '../css/skill.scss'

function Skill() {

  let skillText : any = [
    { 'html' : [
      '웹 접근성에 맞는 시멘틱 웹을 작성합니다.', 
      '누가 보더라도 구조를 파악하기 쉽게 작성합니다.', 
      'DOM을 이해하고 다룰 수 있습니다.'
    ]},
    { 'css' : [
      '무분별한 CSS 남용을 하지 않습니다.', 
      'keyframe 및 styled-components, SASS를 통해 다양한 CSS를 구현합니다.', 
      '반응형 웹을 통해 해상도에 최적화된 레이아웃을 제작합니다.'
    ]},
    { 'js/jquery' : [
      'JS를 CSS, HTML과 접목하여 효율적인 코드를 작성합니다.', 
      'FOR, IF문 등을 자유자재로 다룹니다.', 
      'HOISTING을 방지하기 위해 const, let 키워드를 애용합니다.'
    ]},
    { 'react' : [
      'REACT의 원리를 잘 이해하고 있습니다.', 
      'STATE 관리 및 사용법을 알고 있습니다.', 
      'USEEFFECT를 통해 웹의 LIFECYCLE을 관리할 수 있습니다.'
    ]},
    { 'typescript' : [
      '각 변수에 맞는 TYPE을 설정합니다.', 
      'Error 발견에 따른 Debug 능력을 가지고 있습니다.', 
      '항상 안정적인 코드 관리에 힘쓰고 있습니다.'
    ]},
    { 'github' : [
      'Github를 통해 팀원들과 작업을 할 수 있습니다.', 
      'Github를 통해 버전 관리를 할 수 있습니다.', 
      'Git 외의 업무 협업 관리 프로그램을 사용해 본적이 있습니다.(JIRA 등)'
    ]}
  ];

  return (
    <section className='skill'>
      <h2>SKILL</h2>
      <ul className='skillWrap max1600'>
        {
          skillText.map((a : any) => {
            let skillKey : string = Object.keys(a)[0]; // Object의 key
            let skillValue : any = Object.values(a)[0]; // Object의 value
            return (
              <li className='skillBox'>
                <h3 className='skillTitle'>{skillKey.toUpperCase()}</h3>
                <ul className='skillList'>
                  { skillValue.map((values : any, i : number) => { return ( 
                    
                    <li className='skillDetail'>{values}</li>

                  ) }) }
                </ul>
              </li>
            )
          })
        }
      </ul>
    </section>
  )
}

export default Skill;